export enum ResumeType {
  LINKEDIN = 'LINKEDIN',
  AFFINDA = 'AFFINDA',
}
